import React from 'react'
import { Icon, IconProps } from '@chakra-ui/icon'
import { useColorModeValue } from '@chakra-ui/color-mode'

export function DeerIcon(props: IconProps) {
    return useColorModeValue(<Outline {...props} />, <Fill {...props} />)
}

const Outline: React.FC<IconProps> = props => (
    <Icon viewBox="0 0 72 72" fill="none" {...props}>
        <path
            d="M35.399 14.4575C35.399 14.4575 36.0947 18.9188 39.1215 20.6661C42.1482 22.4136 46.3596 20.7856 46.3596 20.7856C46.3596 20.7856 45.6638 16.3243 42.6372 14.577C39.6103 12.8295 35.399 14.4575 35.399 14.4575Z"
            stroke="currentColor"
            strokeWidth="4.21875"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M18.3376 30.2344H10.5469C5.88705 30.2344 2.10944 34.012 2.10944 38.6719V45.9844C5.17112 45.9844 7.8437 44.3482 9.32251 41.9079"
            stroke="currentColor"
            strokeWidth="4.21875"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M53.5042 15.0469C50.5092 15.0469 47.8344 16.9204 46.8108 19.7352L44.6761 25.606C43.6655 28.3847 41.0247 30.2344 38.068 30.2344H18.3376C13.2616 30.2344 9.14999 34.3554 9.16138 39.4312C8.96858 42.4408 10.1324 45.179 12.0962 47.1045L12.0757 47.9468C11.9957 51.258 10.9778 54.4784 9.14056 57.2344L10.5468 69.8906H17.5781L16.1718 60.0469C19.6192 58.3231 21.7968 54.7997 21.7968 50.9453V49.9219H40.0781V69.8906H47.1093L49.4942 48.4269C52.2807 46.6885 54.1406 43.6042 54.1406 40.0781V27.7031H61.1718C64.2785 27.7031 66.7968 25.1848 66.7968 22.0781L57.279 16.1294C56.1471 15.4221 54.839 15.0469 53.5042 15.0469Z"
            stroke="currentColor"
            strokeWidth="4.21875"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M69.8906 2.10938V3.79688C69.8906 6.12675 68.0017 8.01563 65.6719 8.01563H58.3594C56.0295 8.01563 54.1406 9.9045 54.1406 12.2344V15.0469"
            stroke="currentColor"
            strokeWidth="4.21875"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M61.4531 8.01562V3.79688"
            stroke="currentColor"
            strokeWidth="4.21875"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M38.3906 2.10938V3.79688C38.3906 6.12675 40.2795 8.01563 42.6094 8.01563H49.9219C52.2517 8.01563 54.1406 9.9045 54.1406 12.2344V15.0469"
            stroke="currentColor"
            strokeWidth="4.21875"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M46.8281 8.01562V3.79688"
            stroke="currentColor"
            strokeWidth="4.21875"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
)

const Fill: React.FC<IconProps> = props => (
    <Icon viewBox="0 0 72 72" fill="none" {...props}>
        <path
            d="M4.24027 39.2348C4.28527 35.1664 5.89064 31.3438 8.76839 28.4597C8.84236 28.3856 8.91731 28.3129 8.99255 28.2404C3.91148 28.9942 0 33.3844 0 38.6719V45.9844C0 47.1493 0.944437 48.0937 2.10938 48.0937C3.45586 48.0937 4.75692 47.8426 5.96095 47.3715C4.70236 44.8822 4.09458 42.0817 4.24027 39.2348Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M67.7813 2.10938C67.7813 0.944437 68.7257 0 69.8906 0C71.0556 0 72 0.944437 71.9999 2.10938V3.79688C71.9999 7.2862 69.1611 10.125 65.6717 10.125H58.3592C57.1961 10.125 56.2499 11.0713 56.2499 12.2344V13.3561C57.0007 13.5901 57.7225 13.9191 58.3969 14.3407L67.9148 20.2894C68.5316 20.6748 68.9063 21.3508 68.9063 22.0781C68.9063 25.5731 66.0731 28.4062 62.5781 28.4062H56.25V40.0781C56.25 44.2235 54.1419 48.0135 50.6108 50.2165C50.5634 50.246 50.5142 50.2722 50.4647 50.2978L48.2618 70.1235C48.143 71.1934 47.2417 72 46.1654 72H41.1328C39.9679 72 39.0234 71.0556 39.0234 69.8906V52.0312H24.2573C24.2464 56.0423 22.1482 59.6701 18.7259 61.6781L19.8565 69.5924C19.9717 70.3984 19.6141 71.2167 18.8928 71.6767C18.5462 71.8978 18.137 72 17.7259 72H12.8971C11.8208 72 10.9194 71.1934 10.8006 70.1232L9.49852 58.4052C9.47109 58.1586 9.53156 57.9104 9.66924 57.7038C11.3984 55.11 12.3522 52.0919 12.4275 48.9757C12.4275 48.9757 12.1475 48.7298 12.0257 48.6104C9.55477 46.188 8.2568 42.822 8.45817 39.3657C8.46956 36.3727 9.63858 33.56 11.7547 31.4392C13.8873 29.3019 16.7244 28.1249 19.7437 28.1249H38.068C40.1302 28.1249 41.9889 26.8228 42.6938 24.885L43.8716 21.6456C43.7181 21.6522 43.5625 21.6561 43.405 21.6561C42.1307 21.6562 40.7422 21.4248 39.4988 20.707C37.0481 19.2922 35.9508 16.4372 35.5147 14.8614C35.3633 14.3138 35.4367 13.741 35.721 13.2486C36.0053 12.756 36.4648 12.4064 37.0145 12.2638C38.5972 11.8533 41.6184 11.3763 44.0691 12.7911C45.3326 13.5207 46.2354 14.6319 46.8744 15.7539C48.2466 14.3405 50.0531 13.3795 52.0313 13.0573V12.2344C52.0313 11.0713 51.085 10.125 49.9219 10.125H42.6094C39.12 10.125 36.2812 7.2862 36.2812 3.79688V2.10938C36.2812 0.944437 37.2257 0 38.3906 0C39.5556 0 40.5 0.944437 40.5 2.10938V3.79688C40.5 4.95998 41.4463 5.90625 42.6094 5.90625H44.7188V3.79688C44.7188 2.63194 45.6632 1.6875 46.8281 1.6875C47.9931 1.6875 48.9375 2.63194 48.9375 3.79688V5.90625H49.9219C51.5415 5.90625 53.0201 6.51839 54.1406 7.52273C55.2611 6.51839 56.7398 5.90625 58.3594 5.90625H59.3438V3.79688C59.3438 2.63194 60.2882 1.6875 61.4531 1.6875C62.6181 1.6875 63.5625 2.63194 63.5625 3.79688V5.90625H65.6719C66.835 5.90625 67.7813 4.95998 67.7813 3.79688V2.10938ZM58.2205 19.1094C58.2716 20.2486 57.2145 21.2188 56.1112 21.2188C54.9286 21.2188 54.053 20.2522 54.0018 19.1094C53.9507 17.9702 55.0078 17 56.1112 17C57.2937 17 58.1693 17.9665 58.2205 19.1094Z"
            fill="currentColor"
        />
    </Icon>
)
